import { Web3ConnectWalletModal } from '../Web3ConnectWalletModal';

export type DialogContainerProps = {};

export function DialogContainer(_props: DialogContainerProps) {
  return (
    <>
      {/* 连接钱包弹窗 */}
      <Web3ConnectWalletModal />
    </>
  );
}
